export default {
    BACKEND_URL:'https://querybuilderprodapi.shipsy.in/',
    TIME_BETWEEN_TWO_FETCH_IN_DASHBOARD_SEC: 12000,
    TABLE_ROWS_COUNT: 10,
    GOOGLE_TAG_MANAGER_ID: 'GTM-PGP2834',
    AI_ANALYTICS: {
        BASE_URL: 'https://wb.shipsy.io/webhook/',
        TYPE: 'BI_{{selectedReportType}}_{{customColumnType}}',
        URL: 'ask-ai/shipsy-bi',
    },
};
